<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <v-autocomplete
    v-model="value"
    :rules="[validateRequired]"
    :items="options"
    :label="title"
    clearable
    :required="required"
    :no-data-text="
      $vuetify.lang.current === 'ja'
        ? '検索結果が見つかりません。'
        : $vuetify.noDataText
    "
  ></v-autocomplete>
</template>

<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";

export default Vue.extend({
  name: "InputSuggest",
  mixins: [InputBase],
  props: {
    mlLibJson:Object,
    isLiffMode: Boolean,
    isAdminMode: Boolean,
  },
  computed: {},
  data() {
    return {
      value: null,
    };
  },
  created() {
    let params = Object.assign(
      {
        options: [],
        isRequired: { value: false },
        isRequiredForUser: { value: false },
        input: undefined,
      },
      this.params
    );

    this.itemKey = this.params.itemKey;
    this.options = params.options;
    this.required = params.isRequired.value;
    this.isRequiredForUser = params.isRequiredForUser.value;
    this.value = params.input;
  },
  methods: {
    getValue() {
      return this.value;
    },
    validateRequired() {
      const validateResult = (this.value !== undefined && this.value !== null && this.value !== "") || "必須項目";
      if (this.isAdminMode) {
        return !this.required || validateResult;
      } else if (this.isLiffMode) {
        return (!this.required && !this.isRequiredForUser) || validateResult;
      }
    },
  },
});
</script>
